/** @format */

import { useNavigate } from 'react-router-dom';
import './FirstReDirect.css';

const FirstReDirect = () => {
  const navigate = useNavigate();
  

  return (
    <div>
      <div>
      <img className='logo' src='main.png'/>
      </div>
      <div>
        <h4>환영합니다. Strava 데이터 시각화 서비스 'MileStone' 입니다.</h4>
      </div>
      <div>
        <p>사용자의 데이터를 조회하여 시각화 및 합산하여 제공합니다. <br/>'Strava'와의 안전한 API 연결을 token을 생성하여 데이터를 조회하기에 사용자의 데이터는 안전하게 관리됩니다. <br/>
        데이터는 백엔드 서버의 데이터베이스에 저장되며 서비스 제공 목적 이외에는 사용되지 않습니다.</p>
      </div>
      <div>
        <button className='button'
          onClick={() =>
            window.open(
              'https://strava.com/oauth/authorize?client_id=89942&response_type=code&approval_prompt=auto&scope=read,read_all,activity:read_all,profile:read_all&redirect_uri=https://milestone-1.firebaseapp.com/Loading',
              '_self'
            )
          }>
          시작하기
        </button>
      </div>
    <hr className='sep'/>

    <div className='description'>
        <span>사용 기술 스택</span>
        <div>
          <img src='spring.png'/>
          <img src='logo512.png'/>
          <img src='jpa.png'/>
          <img src='mysql.png'/>
          <img src='aws.png'/>
          <img src='kakao.png'/>
          <img src='strava.png'/>
        </div>
        <span>특징, 주요 기술</span>
        <p>1. JPA와 JDBC를 함께 이용한 영속성 제어. 데이터베이스 접근 기술을 상황에 따라서 다르게 사용함에 따라서 동시성 문제등의 어려움이 있었습니다.</p>
        <p>2. @Async를 이용한 비동기 작업처리. 처리시간이 긴 작업은 서버 단에서 별도의 Thread를 생성해 수행함으로서 사용자에게 더욱 빠르게 리턴 값을 줄 수 있습니다.</p>
        <p>3. ExecutorService의 도입을 이용한 Multi Thread Processing. 하나의 작업을 여러개의 Thread로 나누어 수행함으로서 약 70%의 성능향상을 얻었습니다.</p>
        <a href="https://heavy-pigment-b62.notion.site/Strava-0a823174dfe5447dbdc19bc6ac41f33f?pvs=4">개발 과정</a>
        <span>여담.</span>
        <p>학부생 수준의 미천한 실력이지만 나름 꽤 오랜 시간 들여서 만들어봤습니다....<br/>
        원래는 백엔드 개발을 공부했지만 같이 하다 도망간 프론트 개발자를 대신해 이어서 하느라 GPT로 개발해서 프론트는 정말 개판일 수 있습니다....<br/>
        유사한 서비스도 많고 완성도도 떨어지지만 데이터베이스 연관관계 활용과 Multi threading 학습을 중접으로 개발했습니다.<br/>
        사용간에 문제점 또는 건의사항, 버그 리포트 등은 게시물 댓글 또는 wonwoo42@gmail.com으로 연락주시면 정말 감사하겠습니다.<br/>
        <strong>여러분의 트래픽과 데이터가 제 피와 살과 같은 경험이 되기에 많은 이용 부탁드립니다.</strong> 제발료</p>
    </div>
    </div>
  );
};

export default FirstReDirect;
